<template>
  <slot
    :pickup-call="pickupCall"
    :loading="isCalling"
    :title="$t('common.subscriberPickUpBodyDialog', { from: event.fromName ?? event.from, to: event.targetName ?? event.target })"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { suspendPickupConnectedParty, useWebRTC } from '@/entities/webrtc'

import { NotifyEventData } from '@/shared/components/notifications'
import { CallNotificationType, useCallsNotifications } from '@/shared/composables/calls-notifications'
import { getOfferOptions } from '@/shared/utils/jssip'

const props = defineProps<{
  event: NotifyEventData
  type: CallNotificationType
}>()

const { remove } = useCallsNotifications()
const isCalling = ref(false)

const targetNumber = computed(() => {
  if (props.type === 'pickup') {
    return props.event.interceptNumber || props.event.target
  }
  return props.event.target
})

const pickupCall = async () => {
  const callId = props.event.callId
  if (!targetNumber.value || !callId || isCalling.value) {
    return
  }

  const restoreConnectedParty = suspendPickupConnectedParty(callId)
  isCalling.value = true
  remove(callId, props.type)

  try {
    const { callAsync } = useWebRTC()
    const options = await getOfferOptions(true, false, false, `replaces:${callId}`)
    restoreConnectedParty()
    await callAsync(targetNumber.value, options)
  } finally {
    isCalling.value = false
  }
}
</script>
